import { HttpClient, HttpRequest, HttpEvent } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { environment } from 'environments/environment';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { Result } from '../result';
const CREATE_ACTION = 'AddDepotData';
const UPDATE_ACTION = 'UpdateDepotData';
const DELETE_ACTION = 'DeleteDepotData';
@Injectable({providedIn: 'root'})
export class FileUploadService {
  constructor(private http: HttpClient) { } 
  public GetFileGroups(data:any) {
    return this.http.get<Result>(`${environment.apiUrl}/FileManager/GetAttachmentFileGroups?attachmentfor=`+data);
  }
  public GetFilesfromParentId(data:any) {
    return this.http.get<Result>(`${environment.apiUrl}/FileManager/GetFilesfromParentId?parentid=`+data).toPromise();
  }
  public downloadFile(file: string): Observable<HttpEvent<Blob>> {
    return this.http.request(new HttpRequest('GET', `${environment.apiUrl}/FileManager/Download/?file=${file}`,null, {reportProgress: true,responseType: 'blob'}));
  }
  public GetDocumentUOM() {
   // return this.http.get<Result>(`${environment.apiUrl}/FileManager/GetDocumentUOM`);
   return this.http.get<Result>(
    `${environment.apiUrl}/Common/GetAuxiliary?master=DocumentUOM`
      
  );
  }
  public deleteDocument(data: any) {     
    return this.http.get<any>(`${environment.apiUrl}/FileManager/DeleteDocument?id=` + data)       
  }
  public checkuniqueDocumentID(name)
  {     
    return this.http.get<any>(`${environment.apiUrl}/FileManager/checkuniqueDocumentID?name=` + name);
      
  }
}